<!-- background -->
<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <!-- top bar -->
  <rid-top-bar
    class="block w-full"
    name="Leeslijst | Geen tijd"
    [steps]="matrices().length"
    [progress]="_state.type === 'READING' ? index() : matrices().length"
  />

  <rid-mechanic-content>
    <!-- title -->
    @if (_state.type === 'READING') {
      <rid-mechanic-title [title]="'Lees de woorden hardop in je eigen tempo'" />
    }

    <!-- matrices -->
    <rid-horizontal-pages [pageCount]="matrices().length" (navigated)="index.set($event)">
      @for (matrix of matrices(); track $index) {
        <rid-word-matrix [matrix]="matrix" />
      }
    </rid-horizontal-pages>

    <!-- continue button(s) -->
    @if (_state.type === 'READING' && index() === matrices().length - 1) {
      <rid-bottom-button content="Klaar!" (clicked)="finishReading()" />
    }
    @if (_state.type === 'VIEWING') {
      <rid-bottom-button content="Volgende" (clicked)="finish()" />
    }

    <!-- accuracy toast -->
    @if (_state.type === 'ACCURACY_FEEDBACK') {
      <rid-feedback-comparison-toast
        [config]="accuracyComparison"
        [value]="_state.accuracy"
        [previousValue]="previousAccuracy()"
        (click)="finish()"
        (continued)="finish()"
      />
    }

    <!-- overlay -->
    @if (_state.type === 'RATING') {
      <rid-modal-background />
      <rid-rating-modal (canceled)="view()" (continued)="rate($event)" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
